export const ROUTES = {
  HOME: 'home',
  LOGIN: 'login',
  ITEM_LIST: 'item-list',
  PROFILE: 'profile',
  FAQ: 'faqhelp',
};
